// extracted by mini-css-extract-plugin
export var externalLink = "_a2-0";
export var internalLinkLabel = "_a2-1";